
import { KnowledgeHubBookContextProps, CommentComponentContextProps } from "@models/ui";
import React, { createContext } from "react";


export const KhBookContext = createContext<KnowledgeHubBookContextProps>({
    headerProps: {
        isLoggedIn: false,
        mixpanelId: "",
        position: "",
        customerName: "",
        customerImageUrl: "",
        showManageEvaluations: true,
    },
    comments: [],
    isPopupLinkVisible: false,
    data: null,
    isCommentsPopupOpen: false,
    isSummaryPopupOpen: false,
    isReactionsPop: false,
    isOpen: false,
    isLikeButton: false,
    inputRef: React.createRef<HTMLInputElement>(),
    isLoggedIn: false,
    customerProfile: {
        name: "",
        profile_picture: "",
    },
    likes: {
        noOfLikes: 0,
        IsSelfLiked: false
    },
    mixpanel: undefined,
});


export const CommentComponentContext = createContext<CommentComponentContextProps>({
    comment: {
        id: '',
        username: '',
        username_photo: '',
        username_photo_url: '',
        bio: '',
        comment: '',
        time: new Date().toISOString(),
        reactions: [],
        replies: [],
    },
    level: 0,
});

